import { render, staticRenderFns } from "./PublicNews.vue?vue&type=template&id=91060de4&scoped=true&"
import script from "./PublicNews.vue?vue&type=script&lang=js&"
export * from "./PublicNews.vue?vue&type=script&lang=js&"
import style0 from "./PublicNews.vue?vue&type=style&index=0&id=91060de4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91060de4",
  null
  
)

export default component.exports